<template>
  <div>
    <mu-card-header
      titleClass="largeTitle boldTitle"
      :title="title"
      :subTitle="subTitle">
      <mu-icon-button
        style="margin-right: 8px;"
        @click.native="goBack()"
        slot="avatar"
        icon="chevron_left"
      ></mu-icon-button>
    </mu-card-header>
    <mu-card-text>
      <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
        <mu-flexbox-item align="center">
          <mu-circular-progress :size="46"></mu-circular-progress>
          <br/>
          <span v-text="$t('message.loadingText')"></span>
        </mu-flexbox-item>
      </mu-flexbox>
      <form v-if="!isLoading" @submit.prevent="submitForm()" novalidate>
        <mu-row gutter>
          <mu-col width="100" desktop="80" tablet="80">
            <div v-if="user.diabetes_type.is_diabetic">
              <div class="mu-text-field-label">{{$t('message.labelITakeThisForMy')}} {{user.diabetes_type.diabetes_type}}</div>
              <mu-radio :label="$t('message.labelYes')" name="group" :nativeValue="1" v-model="model.forDiabetes" class="demo-radio"/> <br/>
              <mu-radio :label="$t('message.labelNo')" name="group" :nativeValue="0" v-model="model.forDiabetes"  class="demo-radio"/> <br/>
            </div>

            <mu-row v-if="model.forDiabetes === 0">



              <mu-select-field
                v-if="conditions.length > 0"
                :disabled="!model.treatment_id"
                v-validate="'required'"
                data-vv-value-path="inputValue"
                data-vv-name="condition"
                data-vv-validate-on="none"
                :errorText="errors.first('condition')"
                v-model="model.condition_id"
                hintText="Select from my condititons"
                label="What do you take it for?"
                fullWidth
              >
                <mu-menu-item
                  v-for="item in conditions"
                  :key="'condition-' + item.condition_id"
                  :title="item.condition_label"
                  :value="item.condition_id">
                </mu-menu-item>
              </mu-select-field>
            </mu-row>
            <mu-row gutter>
              <mu-col width="50" tablet="50" desktop="50">
                <mu-text-field
                  :disabled="!model.treatment_id"
                  v-validate="'required'"
                  data-vv-value-path="inputValue"
                  data-vv-name="dosage"
                  data-vv-validate-on="none"
                  :errorText="errors.first('dosage')"
                  min="0"
                  type="number"
                  :label="$t('message.labelDosage')"
                  :hintText="$t('message.placeholderText')"
                  v-model.number="model.defaultDosage"
                  fullWidth
                >
                </mu-text-field>
              </mu-col>

              <mu-col width="50" tablet="50" desktop="50">
                <mu-select-field
                  :disabled="!model.treatment_id"
                  v-validate="'required'"
                  data-vv-value-path="inputValue"
                  data-vv-name="unit_regime"
                  data-vv-validate-on="none"
                  :errorText="errors.first('unit_regime')"
                  :maxHeight="250"
                  v-model="model.unit_id"
                  :scroller="scroller"
                  :hintText="$t('message.selectText')"
                  :label="$t('message.labelUnits')"
                  fullWidth
                >
                  <mu-menu-item
                    v-for="(item, index) in regimes"
                    :value="item.ID"
                    :key="'regime-' + index"
                    :title="localizeRegime(item.regimeUnitLabel)"
                  ></mu-menu-item>
                </mu-select-field>
              </mu-col>
            </mu-row>

            <mu-select-field
              :disabled="!model.treatment_id"
              v-validate="'required'"
              data-vv-value-path="inputValue"
              data-vv-name="frequency"
              data-vv-validate-on="none"
              :errorText="errors.first('frequency')"
              :maxHeight="250"
              v-if="model.treatment_id"
              v-model="model.frequency_id"
              :scroller="scroller"
              :hintText="$t('message.selectText')"
              :label="$t('message.labelHowOften')"
              fullWidth
            >
              <mu-menu-item
                v-for="(item, index) in frequencies"
                :value="item.ID"
                :key="'frequency-' + index"
                :title="$t(localizeFrequency(item.frequency))"
              ></mu-menu-item>
            </mu-select-field>
          </mu-col>
        </mu-row>

        <mu-raised-button
          class="large"
          :disabled="isSaving"
          type="submit"
          fullWidth
          :label="!isSaving ? $t('message.saveText'): $t('message.savingText')"
          secondary
          @click.prevent="submitForm()">
        </mu-raised-button>
        <button type="submit" style="display: none;"></button>
      </form>
      <div style="margin-top: 16px" class="isError" v-if="isError">{{$t('message.medicationAlreadyTrackingError')}}</div>
    </mu-card-text>
  </div>
</template>
<script>

  import ScrollerMixin from '../../../mixins/ScrollerMixin'
  import MedicationFrequencyLocalizerMixin from '../../../mixins/Localization/MedicationFrequencies';
  import MedicationRegimeLocalizerMixin from '../../../mixins/Localization/MedicationRegimes'
  import UserApi from '../../../api/User'
  import MedicationApi from '../../../api/Tracking/Medication'

  export default {
    props: {
      medication: {
        type: Object,
        required: true
      }
    },
    mixins: [
      ScrollerMixin,
      MedicationFrequencyLocalizerMixin,
      MedicationRegimeLocalizerMixin
    ],
    data() {
      return {
        title: this.medication.treatment_name,
        subTitle: this.$t('message.medicationPreferenceUpdateSubTitle'),
        isLoading: true,
        isSaving: false,
        isError: false,
        model: {
          active: null,
          tracking_id: null,
          treatment_id: null,
          frequency_id: null,
          unit_id: null,
          condition_id: null,
          forDiabetes: 0
        },
        conditions: [],
        regimes: [],
        frequencies: []
      }
    },
    watch: {
      'model.frequency_id': function () {
        let self = this;
        if (self.model.frequency_id) {
          self.model.frequency_label = self.frequencies.filter(function (frequency) {
            return frequency.ID === self.model.frequency_id
          })[0].frequency
        }
      },
      'model.unit_id': function () {
        let self = this;
        if (self.model.unit_id) {
          self.model.unit_label = self.regimes.filter(function (unit) {
            return unit.ID === self.model.unit_id
          })[0].regimeUnitLabel
        }
      },
      'model.condition_id': function () {
        let self = this;
        if (self.model.condition_id) {
          self.model.condition_label = self.conditions.filter(function (condition) {
            return condition.condition_id === self.model.condition_id
          })[0].condition_label
        }
      }
    },
    mounted() {
      let self = this;
      self.model.active = self.medication.active;
      self.model.defaultDosage = self.medication.defaultDosage;
      self.model.tracking_id = self.medication.tracking_id;
      self.model.forDiabetes = self.medication.forDiabetes;
      UserApi.getUserConditions()
        .then(function (response) {
          self.conditions = response.data;
          self.model.condition_id = self.medication.condition_id;
          MedicationApi.regimeUnitsGet()
            .then(function (response) {
              self.regimes = response.data;
              self.model.unit_id = self.medication.unit_id;
              MedicationApi.regimeFrequencysGet()
                .then(function (response) {
                  self.frequencies = response.data;
                  self.model.frequency_id = self.medication.frequency_id;
                  self.isLoading = false;
                });
            });
        });
      self.model.treatment_id = self.medication.treatment_id;
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid) {
            self.isSaving = true;
            MedicationApi.updateMedication(self.model)
              .then(function (response) {
                self.isSaving = false;
                self.$router.push({
                  name: 'SettingsMedication'
                });
              })
          }
          else {
           self.isSaving = false;
          }
        })
      },
      goBack() {
        let self = this;
        self.$router.push({
          name: 'SettingsMedication'
        })
      }
    },
    computed: {
      user() {
        let self = this;
        return self.$store.state.user.scope;
      }
    }
  }
</script>
<style scoped>
  .mu-text-field-label {
    color: #0179d5;
    text-transform: uppercase;
    font-weight: 500;
    font-size: initial;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?2e04ac2e